import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, bootstrapping } = useAuth();

  if (bootstrapping) {
    return (
      <div
        data-testid="auth-bootstrapping"
        className="min-h-screen flex items-center justify-center bg-honda-bg text-honda-muted text-sm"
      >
        Memuat sesi...
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    const fallback = user.role === "sales" ? "/sales/home" : "/admin/dashboard";
    return <Navigate to={fallback} replace />;
  }
  return children;
};
